import {
  PrimaryButton,
  SecondaryButton,
} from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { DEPRECATED_Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import { ExpressCheckoutOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ExpressCheckoutOutlined";
import classnames from "classnames/bind";

import styles from "./ExpressCheckoutButton.module.scss";

const cx = classnames.bind(styles);

type ExpressCheckoutButtonProps = {
  className?: string;
  disabled: boolean;
  isShipFromStore: boolean;
  asPrimaryButton: boolean;
  isSubmitting: boolean;
  handleAddToBasketClick: () => void;
  ctaPremiumDesign?: boolean;
};

export const ExpressCheckoutButton = ({
  disabled,
  isShipFromStore,
  asPrimaryButton = false,
  handleAddToBasketClick,
  isSubmitting,
  className,
  ctaPremiumDesign = false,
}: ExpressCheckoutButtonProps) => {
  const ButtonComponent = asPrimaryButton ? PrimaryButton : SecondaryButton;

  return (
    <>
      {!isShipFromStore && (
        <DEPRECATED_Message
          type="information"
          title=" "
          body="You can only buy this item on its own, any other items in your basket will be saved. Delivery and payment methods are available when you continue to checkout."
        />
      )}
      <ButtonComponent
        id="basket:add:express:button"
        disabled={disabled}
        submitting={isSubmitting}
        onClick={handleAddToBasketClick}
        className={cx("button", className, {
          nonPremiumButton: !ctaPremiumDesign,
        })}
        data-testid="basket:add:express"
        labelText="Express checkout"
        icon={ExpressCheckoutOutlined}
        width="full-width"
      />
    </>
  );
};
